import { FilterJsonProperties, FilterJsonType } from '@/entities/catalog-old'

export const getFilterUrlFromForm = (form: HTMLFormElement): string => {
	const formData = Array.from(new FormData(form))

	const filterObj = formData.reduce<FilterJsonProperties>((acc, [name, value]) => {
		const stringValue = value.toString()

		if (!acc[name]) {
			acc[name] = {
				type: FilterJsonType.Default,
				value: [stringValue === 'on' ? 'Да' : stringValue]
			}
		} else {
			acc[name].value = [...acc[name].value, stringValue]
		}

		return acc
	}, {})

	return JSON.stringify(filterObj)
}
